import { Chip, FormHelperText, MenuItem, Select } from '@material-ui/core'

import * as R from 'ramda'
import React, { FC } from 'react'
import { Controller, useFormContext, useWatch } from 'react-hook-form'

interface FormMultiSelectInputInterface {
  fieldName: string
  selections: string[]
  defaultValue?: string[]
  rules?: any
  required?: boolean
  disable?: boolean
  noSort?: boolean
}

const FormMultiSelector: FC<FormMultiSelectInputInterface> = ({
  fieldName,
  selections,
  defaultValue,
  rules = {},
  required = false,
  disable = false,
  noSort = false
}: FormMultiSelectInputInterface) => {
  const { control, setValue, getValues } = useFormContext()
  const value = useWatch({ control, name: fieldName })
  // TODO: add empty selection if required is false

  return (
    <Controller
      control={control}
      name={fieldName}
      rules={{ ...rules, required }}
      value={value}
      defaultValue={defaultValue}
      as={
        <>
          <Select
            id={`${fieldName}-multi-select`}
            fullWidth
            value={value}
            defaultValue={defaultValue}
            disabled={disable}
            renderValue={(selected) => (
              <>
                {(selected as string[]).map((v) => (
                  <Chip key={v} label={v} style={{ margin: '0px 2px' }} />
                ))}
              </>
            )}
            onChange={(event: React.ChangeEvent<{ value: unknown }>) => {
              const selectedValue = event.target.value
              const currentList = (getValues(fieldName) as string[]) ?? []
              const newList = R.includes(selectedValue, currentList)
                ? R.reject(R.equals(selectedValue), currentList)
                : [...currentList, selectedValue]
              setValue(fieldName, newList)
            }}
          >
            {(noSort
              ? selections
              : R.sortBy(R.compose(R.toLower), selections)
            ).map((item) => (
              <MenuItem key={item} value={item}>
                {item}
              </MenuItem>
            ))}
          </Select>
          {required && <FormHelperText>Required</FormHelperText>}
        </>
      }
    />
  )
}

export default FormMultiSelector
